import email from './email';

export { default as email } from './email';

export default {
  email,
};
